import PropTypes from 'prop-types';

const formatRecData = (rec) => {
  const formattedRec = {
    id: rec.id,
    type: rec.type,
    message: rec.formattedCopy,
    brandProfileId: rec.brandProfileId,
    primaryAction: rec.primaryAction,
    primaryItem: rec.primaryItem,
    metric: rec.metric,
    finishRate: rec.finish_rate,
    primaryItemName: rec.primaryItemName,
    fromDate: rec.fromDate,
    toDate: rec.toDate
  };

  return formattedRec;
};

export const recShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  primaryItem: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    title: PropTypes.string,
    name: PropTypes.string
  }),
  primaryAction: PropTypes.shape({
    text: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired
  }).isRequired,
  fromDate: PropTypes.string.isRequired,
  toDate: PropTypes.string.isRequired
});


export default formatRecData;



// WEBPACK FOOTER //
// ./app/javascript/app/components/recommendations/recommendation_mapper.js